export default __webpack_public_path__ + "images/e744a63de3017586f7407fefd6729789.svg";